// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.by-country-card {
  background: transparent;
  overflow: visible;
}
.by-country-card:hover {
  background: transparent;
}
.by-country-card .content {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 20px;
}
.by-country-card .no-data-avaliable-container {
  background-color: transparent;
}
.by-country-card .loading-component {
  align-self: center;
  width: 100%;
  height: 300px;
}`, "",{"version":3,"sources":["webpack://./src/components/MapAndCountriesCard/index.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,iBAAA;AACF;AACE;EACE,uBAAA;AACJ;AACE;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AACJ;AAEE;EACE,6BAAA;AAAJ;AAGE;EACE,kBAAA;EACA,WAAA;EACA,aAAA;AADJ","sourcesContent":[".by-country-card {\n  background: transparent;\n  overflow: visible;\n\n  &:hover {\n    background: transparent;\n  }\n  .content {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-column-gap: 20px;\n  }\n\n  .no-data-avaliable-container {\n    background-color: transparent;\n  }\n\n  .loading-component {\n    align-self: center;\n    width: 100%;\n    height: 300px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
